export default "__VITE_ASSET__h9AD1OMo__"